import styled from 'styled-components';

const NonGapStackBlock = styled.div`
  flex-direction: column;
  display: flex;
  width: 100%;
`;

export default NonGapStackBlock;
